import React, { useState } from 'react'
import useStoreBusiness from '../BusinessDataDR15/BusinessStore/Store'
import codeIcon from '../SearchFilters/images/code.svg'
import useStore from '../Store/Store'
import useStoreProduct from '../ProductDataDR/ProductStore/Store'
import useStorePeople from '../StorePeople/Store'
import ModalApiCall from './modalApiCall'
import styles from './styles.module.css'

function ViewApiCall ({ dataType }) {
  const {
    queryStore: queryStoreProperty,
    isQueryLoading: isQueryLoadingProperty
  } = useStore()
  const { queryStore: queryStorePeople, isQueryLoading: isQueryLoadingPeople } =
    useStorePeople()
  const {
    queryStore: queryStoreBusiness,
    isQueryLoading: isQueryLoadingBusiness
  } = useStoreBusiness()
  const {
    queryStore: queryStoreProduct,
    isQueryLoading: isQueryLoadingProduct
  } = useStoreProduct()

  const queryStore =
    dataType === 'property'
      ? queryStoreProperty
      : dataType === 'people'
      ? queryStorePeople
      : dataType === 'business'
      ? queryStoreBusiness
      : dataType === 'product'
      ? queryStoreProduct
      : null

  const isQueryLoading =
    dataType === 'property'
      ? isQueryLoadingProperty
      : dataType === 'people'
      ? isQueryLoadingPeople
      : dataType === 'business'
      ? isQueryLoadingBusiness
      : dataType === 'product'
      ? isQueryLoadingProduct
      : false

  const [isModalVisible, setIsModalVisible] = useState(false)

  const toggleModal = () => {
    if (!isQueryLoading && queryStore) {
      setIsModalVisible(!isModalVisible)
    }
  }

  const isDisabled = !queryStore || isQueryLoading

  return (
    <div className={styles.ViewApiCallIndexContainer}>
      <span
        className={`${styles.ViewApiCallIndexText} ${
          isDisabled ? styles.ViewApiCallIndexTextDisabled : ''
        }`}
        onClick={isDisabled ? null : toggleModal}
      >
        View API call
      </span>
      <img
        src={codeIcon}
        alt='codeIcon'
        className={`${styles.ViewApiCallIndexIcon} ${
          isDisabled ? styles.ViewApiCallIndexIconDisabled : ''
        }`}
        onClick={isDisabled ? null : toggleModal}
      />

      {isModalVisible && (
        <ModalApiCall
          queryStore={queryStore}
          onClose={() => setIsModalVisible(false)}
          isQueryLoading={isQueryLoading}
          dataType={dataType}
        />
      )}
    </div>
  )
}

export default ViewApiCall
